"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var Sunburst = /** @class */ (function (_super) {
    __extends(Sunburst, _super);
    function Sunburst() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sunburst.prototype.defaultOptions = function () {
        return {
            _innerRadius: 20,
            _toolTipFunc: function (d) { return d.data.name + ": " + d.value; },
            _radianFunc: function (d) { return d.size; },
            _radiusFunc: function (d) { return 1; },
            _sortingFunc: function (a, b) { return b.size - a.size; },
        };
    };
    Sunburst.prototype.init = function () {
        _super.prototype.init.call(this);
        this._arcs.options({
            _$mouseEnter: function (d, i, g) {
                var parIndexes = d.ancestors().map(function (par) { return par.index; });
                g.forEach(function (el, j) {
                    g[j].style.opacity = parIndexes.indexOf(j) !== -1 ? "1" : "0.2";
                });
            },
            _$mouseLeave: function (d, i, g) {
                g.forEach(function (el, j) {
                    g[j].style.opacity = "1";
                });
            },
        });
    };
    Sunburst.prototype.prepare = function () {
        _super.prototype.prepare.call(this);
        var maxValue = d3.max(this._radianData, function (d) { return d.y1; });
        var minValue = d3.min(this._radianData, function (d) { return d.y0; });
        this.scale = d3.scaleLinear()
            .domain([minValue, maxValue])
            .range([this._getInnerRadius(), this._outerRadius]);
    };
    Sunburst.prototype._getRadianData = function () {
        var partition = d3.partition()
            .size([2 * Math.PI, this._outerRadius * this._outerRadius]);
        var root = d3.hierarchy(this.datum)
            .sum(this.getOption("_radianFunc"))
            .sort(this.getOption("_sortingFunc"));
        return partition(root).descendants()
            .filter(function (d) { return d.x1 - d.x0 > 0.005; })
            .map(function (node, i) {
            node.index = i;
            return node;
            // FIXME: (node, i) => node.index = i is supposed to return Array<node>. TypeScript believes it returns a number array.
        });
    };
    Sunburst.prototype._getArcInnerR = function () {
        var _this = this;
        return function (d, i) { return _this.scale(d.y0); };
    };
    Sunburst.prototype._getArcOuterR = function () {
        var _this = this;
        return function (d, i) { return _this.scale(d.y1); };
    };
    Sunburst.prototype._getStartAngle = function () {
        return function (d, i) { return d.x0 / Math.PI * 180; };
    };
    Sunburst.prototype._getEndAngle = function () {
        return function (d, i) { return d.x1 / Math.PI * 180; };
    };
    Sunburst.prototype._getToolTipData = function () {
        return this._radianData.map(this.getOption("_toolTipFunc"));
    };
    return Sunburst;
}(_1.BasePieChart));
exports.Sunburst = Sunburst;
//# sourceMappingURL=sunburst.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/sunburst.js
// module id = 1146
// module chunks = 0 1